<!-- @component  Shows encounter map in prep and play modes, requires game.encounter and view.map set -->
<script module>
		export let mapElement = null

		export function scroll_to(location, force = false)  {}
		export function show_strikes(inflicts = null) {}
		export function show_marker(loc) {}

		class Map {
				element = null						// HTML map element
				current = $state(null)		// current map
				pointer = $state({col: 0, row: 0, map: "", obj: ""})		// current mouse/pointer position
				perspective = $state(null)
				superimposed = $state(false)
				selected = $state(null)
				path = $state(null)         // movement

				switch_map(mapID) {}
				isVisible(entity) {return this.map && entity.position && entity.position.map === this.map.ID && entity.operative}

				scroll_to(location, force = false)  {}
				show_strikes(inflicts = null) {}
				show_marker(loc) {
					/**
		 * centers the map the position given in data
		 *
		 * @param {object} data - data from server, might contain attribute 'loc'
		 */
						console.log(`ENCOUNTER - show marker at `, loc)
						if (!loc) return
						loc = Location.from_loc(loc)
						view.map.ID = loc.map
						scroll_to(loc)
				}
		}

		// ToDo: move here  class Location {}

		export const map = new Map()
		globalThis.map = map
</script>


<!-------------------------------- HTML -------------------------------------->

<section id=encounter onclose={view.close_dialog} ondblclick={reload_zoom} >
	{#if view.map}
	<pinch-zoom bind:this={pinchZoom} id='pinch-zoom' data-help="map" class="pinchable" class:marking
							onmousemove={update_mouseLoc} onpointerdown={record_coord} onclick={process_click}
							oncontextmenu={compose_menu} ontouchstart={touchstart} ontouchend={touchend} ontouchmove={touchend}
							ondragover={drag_over} ondrop={drop_onto}
							style:--resolution="{view.map.scale}px" style:height={(game.ID) ? "unset" : "100vh"}
							style:--timestep="{timestep}s">
		<img bind:this={mapImg} id='mapImg' data-help="map" class="layer pinchable"
				 src={view.map.filepath} alt="" onload={size_map} />
		<svg bind:this={svgElem} class="layer nopinch">
				<!-- static environments -->
				{#if user.isMaster}
					{#each obstacles as obstacle}
						{@html obstacle}
					{/each}
				{/if}
				<defs>
						<marker id="arrowhead" markerWidth="6" markerHeight="5" refX="5" refY="2" orient="auto" stroke-width="2">
								<polygon points="0 0, 5 2, 0 4" />
						</marker>
				</defs>
				<line x1="0" y1="0" x2="1" y2="1" class="arrow" />
				<!-- path of movemtent and endpoint (=aim) -->
				{#if pathData}
						<polyline points={pathData.points} stroke={pathData.stroke} stroke-dasharray="10 {pathData.gaps}" stroke-width=20 fill="none"/>
						<g>
								<rect x={pathData.aimCoord.x - 20} y={pathData.aimCoord.y - 5} width="40" height="10" transform="rotate(45 {pathData.aimCoord.x} {pathData.aimCoord.y})" fill="lightgreen"/>
								<rect x={pathData.aimCoord.x - 20} y={pathData.aimCoord.y - 5} width="40" height="10" transform="rotate(-45 {pathData.aimCoord.x} {pathData.aimCoord.y})" fill="lightgreen"/>
						</g>
				{/if}
		</svg>
			{#if aoeStyleStr}
				<div id=effectsLayer class="layer nopinch" style={aoeStyleStr}> </div>
			{/if}
			<div id=environsLayer class="layer">
				{#each environs as environ (environ.ID)}
					<Environ {environ} />
				{/each}
				{#if appearArea}
					<Environ environ={appearArea} />
				{/if}
			</div>
			<div id=tokensLayer class=layer>
				{#each tokens as token (token.ID)}
					<Token {token} />
				{/each}
			</div>
			{#if view.option?.radius}
				<div class=aimArea
						 style:left={(mouseLoc.col - view.option.radius) * fieldResolution * pinchZoom.scale + "px"}
						 style:top={(mouseLoc.row - view.option.radius) * fieldResolution * pinchZoom.scale + "px"}
						 style:width={2 * view.option.radius * fieldResolution + "px"}
						 style:height={2 * view.option.radius * fieldResolution + "px"}
						 style:background-color={calc_activityColor(view.option.action)}>
				</div>
			{/if}
			{#if game.marker}
				{@const marker = (game.marker) ? Location.from_loc(game.marker).to_coord() : null}
				<div class="markers">
					<img id=crossMark class="layer nopinch hide" src="/static/buttons/crossmark.png" alt="" transition:fade={{duration: 1000}}
							 style="left: {marker.x}px; top: {marker.y}px;" >
				</div>
			{/if}
	</pinch-zoom>

	<aside id=positions data-help="encounter">
		<p>Position: {mousePos}</p>
		<p>Distanz: {distance} F = {distance * 2} m</p>
		{#if user.isMaster}
			<p>{watchTxt}</p>
			{#if game.maps.size > 1}
				<div class="mapSelect-box" data-help="mapselect">
					<Select field='map' help="mapselect" value={view.map.ID} options={game.maps.keys().toArray()} separate onchange={select_map}/>
					<div>
						<input type=checkbox id=superCheck data-help="mapselect" bind:checked={view.superimposed}>
						<label for="superCheck">alle</label>
					</div>
				</div>
			{/if}
			<button class="button miniButton" data-help="marker" class:marking class:marked={game.marker} onclick={toggle_marking}>
					<img src="/static/buttons/crossmark.png" alt="Fokus">
			</button>
		{/if}
	</aside>
	{/if}
</section>

<!--  z-index
    0:  map
    1:
    9:  activity symbol
    10: HTML control elements of app (should not require z-index)
-->



<script>
		import {user, game, view, send_request, send_data, fetch_data, report_issue} from "../client.svelte.js"
		import {Location, protoActions, notEmpty, fieldResolution, impactHue, calc_defaultCS, noPersona, calc_activityColor} from "../core.js";
		import {compose_options} from "../dialogs/OptionDialog.svelte";
		import {fade} from "svelte/transition";
    import {onDestroy, onMount} from "svelte";
		import {tick} from "svelte";
		import Select from "../elements/Select.svelte";
    import Token from "./Token.svelte";
    import Environ from "./Environ.svelte";

    let pinchZoom, mapImg, svgElem     // main map data

    let mousePos = $state("")
    let mouseLoc = new Location({col: 0, row: 0, map: view.map.ID}, null)
    let mouseCoord = {x: null, y: null}, menuCoord, screenCoord
    let distance = $state(0)
		let watchTxt = $state("Wahrnehmung")
    let selection
    let pathData = $derived((game.inEncounter && view.persona) ? show_path(game.activities.get(view.persona.activity)) : null)
    let timestep = 1	// speed of proceeds:  typically 1 step in the game (1s) is played in 1 sec in reality
    let appearArea = null
    let aoeStyleStr = null, aoeStyle = null
    let touchTimer
    let selected
		let marking = $state(false)			// flag if marker is currently being set
		let masterMap = null

    onMount(() => {mapElement = pinchZoom})
    onDestroy(() => {mapElement = null})

    let tokens = $derived.by(() => {
      if (game.inEncounter) {
        if (user.isMaster) {
          // const allFighters = (view.superimposed) ? Array.from(game.personas.values()) : view.map.entities.map(entID => game.personas.get(entID))
	        const allFighters = game.personas.values()
		        .filter(pers => pers?.operative && pers?.position && (view.superimposed || pers.position.map === view.map.ID)).toArray()
	        console.assert(!view.superimposed || allFighters.length === view.map.entities.length, `ENCOUNTER: number of entities on map does not match game.personas`)
          return allFighters
        } else if (!view.persona.position) {
          appearArea = game.appearArea
					if (appearArea)
          	return [Object.assign({}, noPersona, view.persona, {position: game.appearArea, size: 0, operative: true, visibility: game.appearArea.radius})]
					else
						return []
        } else
          return game.personas.values()
	          .filter(pers => pers?.operative && pers.position && (view.persona.detecteds.includes(pers.ID) || pers.ID === view.persona.ID))
	          .toArray()
      }
      /// app in adventure preparation mode
      if (view.section && view.map) {
        return Object.values(Object.fromEntries(
          user.deployments.values()
						.filter(deploy => deploy.ADVT === view.adventure.ID && deploy.SECT === view.section.SECT && deploy.map === view.map.LAYER)
						.map(deploy => {
							const appearChar = (deploy.charID === 'HEROES') ? {affiliation: 'fellow', level: null} : user.characters.get(deploy.charID)
              const callsign = deploy.ID.split("~")[1]
							const appearPers = Object.assign({}, appearChar, {
                ID: callsign, TYPE: 'Deploy', callsign: callsign, charID: appearChar.ID, character: user.characters.get(appearChar.ID),
                deployID: deploy.ID, position: new Location(deploy), size: appearChar.size ?? 1,
								rank: deploy.rank, condition: deploy.condition, affil: deploy.affil ?? appearChar.affiliation,
								orientation: null, affects: {}, hide: {}, })
							return [deploy.ID, appearPers] })
						.toArray()
				))
			}
			return []
		})
	let environs = $derived(view.map.affects.map(effID => game.effects.get(effID)) ?? [])
	let obstacles = $derived(view.map.environs?.map(({svg}) =>
	  (svg.charAt(1) === 'g') ?
			svg.slice(0, 2) + ` transform="scale(${fieldResolution})"` + svg.slice(2) :
			svg.slice(0, -2) + `transform="scale(${fieldResolution})" />`) ?? [])

		// $inspect(`ENCOUNTER - tokens`, tokens)

		$effect( () => {
				if (marking)  return
				const location = (game.marker) ? Location.from_loc(game.marker) : (selected) ? view.persona.position : null
				scroll_to(location, true)
		})
    // const internalUpdater = internalComm.subscribe(internal => {
    //     if ('aimArea' in internal) {
    //         if (internal.aimArea) {
    //             const radius = internal.aimArea.size * defaultResolution
    //             const mouseCoord = mouseLoc.to_coord()
    //             aimAreaStyle = `left: ${(mouseCoord.x - radius) * pinchZoom.scale}px; top: ${(mouseCoord.y - radius) * pinchZoom.scale}px;
    //                             width: ${2 * radius}px; height: ${2 * radius}px`
    //         } else
    //             aimAreaStyle = null
    //     }

    function select_map(e) {
				masterMap = e.target.value
        view.switch_map(e.target.value)
    }

    function size_map() {
        if (!mapImg) return
        mapImg.width = mapImg.naturalWidth * fieldResolution / view.map.scale
        // svg container has to cover the whole map for all svg drawings to be shown
        svgElem.style.width = mapImg.width + "px"
        svgElem.style.height = mapImg.height + "px"
        // scroll current entity into view
        if (view.persona)
					if (view.persona.position && view.map.ID === view.persona.position.map)
            scroll_to(view.persona.position, true)
		      else if (game.appearArea) {
						const centerPos = new Location(game.appearArea)
			      scroll_to(centerPos, true)
		      }
		}

    function select_super(e) {
        view.superimposed = e.target.checked
		}


		/**
	 * mouseLoc always shows the current mouse location (position and fighter) *
	 */
		function update_mouseLoc(event) {
				const viewedFgt = mouseLoc.fgt
				// no mouse location outside map
				if (event.target.id === "pinch-zoom")
					return
				/// update mouseLoc from event
				mouseLoc.update(event, view.map.scale)
				/* ToDo: move conversion from core to here
				let x = event.offsetX, y = event.offsetY, fgt
				if (event.type === 'touchstart') {
						const bcr = event.target.getBoundingClientRect();
						x = (event.targetTouches[0].clientX - bcr.x) / (pinchZoom?.scale ?? 1)
						y = (event.targetTouches[0].clientY - bcr.y) / (pinchZoom?.scale ?? 1)
						screenCoord = {x: event.targetTouches[0].clientX, y: event.targetTouches[0].clientY}
				} else
						screenCoord = {x: event.clientX, y: event.clientY}
				if (event.target && event.target.id !== "map") {
						x += event.target.offsetLeft
						y += event.target.offsetTop
						mouseLoc.fgt = (event.target.classList.contains('areaEffect')) ? null : event.target.dataset.char ?? null
				} else {	// this branch captures if target is not set to mapImg but to underlying element
						debugger;
						// x += map._positioningEl.offsetLeft - map.x
						// y += map._positioningEl.offsetTop - map.y
						// this.fgt = null
				}
				mouseLoc.col = x / fieldResolution
				mouseLoc.row = y / fieldResolution
				mouseLoc.map = view.map.ID
				*/

				mousePos = mouseLoc.toString()
				/// calculate distance from current character
				if (view.persona?.position) {
					distance = Math.hypot(mouseLoc.col - view.persona.position.col, mouseLoc.row - view.persona.position.row).toFixed(1)
				}
				if (user.isMaster && mouseLoc.fgt && view.persona) {
						if (notEmpty(view.persona.awareness) && mouseLoc.fgt in view.persona.awareness) {
								const aware = view.persona.awareness[mouseLoc.fgt]
								watchTxt = `Wahrn: ${Math.round(aware.watch)} / ${view.persona.percept?.total} vs. ${aware.hide} verb.`
						} else if (view.persona)
								watchTxt = `Sichtweite: ${Math.round(view.map.visrange * (1 + view.persona.percept?.total / 25) * 10) / 10}`
						else
								watchTxt = ""
				}
				// drag area effect indicator to current position if action selected
				const actionData = protoActions[selected]
				if (actionData && actionData.aiming.select !== 'self') {
						const coord = mouseLoc.to_coord()
						const radius = (actionData.aiming) ? actionData.aiming.limit / 2 : 0.5
						const offset = radius * fieldResolution
						const diam = 2 * radius * fieldResolution
						aoeStyleStr = `left: ${coord.x - offset}px; top: ${coord.y - offset}px; width: ${diam}px; height: ${diam}px; background: ${actionData.cardColor}`
						aoeStyle = {left: coord.x - offset, top: coord.y - offset, width: diam, height: diam, background: actionData.cardColor}
				}
				/// if change in viewed fighter then show_detecteds or refresh normal visibility
				if (user.isMaster && viewedFgt !== mouseLoc.fgt) {
						const viewerID = (mouseLoc.fgt && (!game.inEncounter || game.personas.get(mouseLoc.fgt).operative)) ? mouseLoc.fgt : null
						view.perspective = viewerID
						// console.log(`MAP: show viewpoint of ${viewerID}`)
				}
		}

	function pos_from_event(event) {
    let x = event.offsetX, y = event.offsetY, fgt
    if (event.type === 'touchstart') {
      const bcr = event.target.getBoundingClientRect();
      x = (event.targetTouches[0].clientX - bcr.x);
      y = (event.targetTouches[0].clientY - bcr.y);
      // x = (event.targetTouches[0].clientX - bcr.x) / (pinchZoom?.scale ?? 1)
      // y = (event.targetTouches[0].clientY - bcr.y) / (pinchZoom?.scale ?? 1)
      screenCoord = {x: event.targetTouches[0].clientX, y: event.targetTouches[0].clientY}
    } else
      this.screenCoord = {x: event.clientX, y: event.clientY}
    if (event.target && event.target.id !== 'pinch-zoom') {
        x += event.target.offsetLeft
        y += event.target.offsetTop
        fgt = (event.target.classList.contains('areaEffect')) ? null : event.target.dataset.char ?? null
    } else if (!(event instanceof DragEvent)) {	// this branch captures if target is not set to mapImg but to underlying element
        x += pinchZoom._positioningEl.offsetLeft - pinchZoom.x
        y += pinchZoom._positioningEl.offsetTop - pinchZoom.y
        fgt = null
    }
    return {col: x / fieldResolution, row: y / fieldResolution, map: view.map.ID, fgt}
	}

    /** scroll location into viewpoint **/
		scroll_to = (loc, force = false) => {
				if (!loc || !(loc instanceof Location)|| !mapElement)
					return
				const coord = loc.to_coord()
				coord.x = coord.x * mapElement.scale
				coord.y = coord.y * mapElement.scale
        // scroll if outside of the core 80% of the map or force
        if ((coord.x + mapElement.x < 0.05 * mapElement.clientWidth) || (coord.x + mapElement.x > 0.95 * (mapElement.clientWidth - 420)) ||
            (coord.y + mapElement.y < 0.05 * mapElement.clientHeight) || (coord.y + mapElement.y > 0.95 * mapElement.clientHeight) || force) {
            mapElement.setTransform({
                x: Math.min(0, mapElement.clientWidth / 2 - 200 - coord.x),
                y: Math.min(0, mapElement.clientHeight / 2 - coord.y)
            })
        }
				if (loc.map !== view.map.ID)
						view.switch_map(loc.map)
		}

    function show_action(actionID, place, start) {
		/*** ToDo: move from OptionDialog to here
			- set this.action = $state(null)
			- pass parameters place and start in this.cardParams
		    - OptionDialog is reactive to view.action
		*/
		}

	show_strikes = (inflicts = null) => {
		if (!inflicts)  inflicts = []   // in case null was passed
		let viewImpacts = {}
		for (let infl of inflicts) {
	        if (infl === undefined)  continue
	        for (let [fgt, imp] of Object.entries(infl.impacts ?? {}))
	            if (fgt in viewImpacts)
	                viewImpacts[fgt] = {ID: "mult", 'kind': viewImpacts[fgt].kind, 'effect': viewImpacts[fgt].effect + " & " + imp.effect}
	            else
	                viewImpacts[fgt] = imp
		}
		if (Object.keys(viewImpacts).length === 0)
	        viewImpacts = null
		//ToDo: where to store the impact information?
	}



		/*** MAP: drawing ***/

    function show_path(movement) {
        if (!movement || !movement.itinerary)
            return null
        // console.log(`ENCOUNTER: showing path of movement `, $state.snapshot(movement.itinerary))
        /// show movement lines
        let stepPos, startCoord, stepCoord, stepVector, vectorLength, normalVect, lineColor, attribs, points
        const startPos = new Location(view.persona.position)
        startCoord = startPos.to_coord()
        for (let segm of movement.itinerary.slice(movement.leg)) {
						// catch if segment data is incomplete
		        if (!segm.destin) {
								console.error(`ENCOUNTER - incomplete segment data: `, $state.snapshot(segm))
				        return null
		        }
            stepPos = (Array.isArray(segm.destin)) ? Location.from_array(segm.destin) : new Location(segm.destin)
            stepCoord = stepPos.to_coord()
            stepVector = {x: stepCoord.x - startCoord.x, y: stepCoord.y - startCoord.y}
            vectorLength = Math.hypot(stepVector.x, stepVector.y)
            normalVect = stepVector
            if (vectorLength > 0) normalVect = {
                x: -stepVector.y / vectorLength * 10,
                y: stepVector.x / vectorLength * 10
            }
            if (!points) points = `${(startCoord.x + normalVect.x).toFixed(2)},${(startCoord.y + normalVect.y).toFixed(2)}`
            points += ` ${(stepCoord.x + normalVect.x).toFixed(2)}, ${(stepCoord.y + normalVect.y).toFixed(2)}`
        }
        return {points: points, stroke: `hsl(${impactHue[protoActions[movement.action]?.kind ?? 'move']} 100% 50%)`, gaps: 64 * movement.speed, aimCoord: stepCoord}
		}


		/**** MAP - check for long-touch events ****/

		// Alternative: https://github.com/john-doherty/long-press-event  evtl. zusammen mit  https://svelte.dev/docs/svelte/$host

		function touchstart(e) {
		    // console.log(`ENCOUNTER - touchstart`)
		    e.preventDefault()
		    update_mouseLoc(e)
		    view.close_dialog()
		    selection = mouseLoc    //Old: Location.from_event(e, view.map.ID)
		    menuCoord = {x: e.targetTouches[0].clientX, y: e.targetTouches[0].clientY}
		    touchTimer = setTimeout(compose_menu, 600);
		}

    function touchend(e) {
			/** stops short touches from firing the event */
			if (touchTimer) {
				view.close_dialog()
				if (selection.fgt && selection.fgt in game.playables)
					view.select_character(selection.fgt)
			}
			clearTimeout(touchTimer);
			touchTimer = null
			selection = null
		}

    function compose_menu(e) {
				if (e)  e.preventDefault()	// required for iOS where compose menu is triggered by timer
		    if (pinchZoom._pointers.size > 1)
						return
        pinchZoom._pointers.clear()
				touchTimer = null
				selection = mouseLoc    // Location.from_event(e, view.map.ID)
				let options
				if (e instanceof Event) {
						if (user.isMaster && e.target.parentElement.id === 'environsLayer') {
								selection.env = e.target.id.substring(2)
								options = Object.assign({Environ: [{instruct: 'REMOVE', label: `${selection.env.split(" ")[0]} beenden`, subject: view.map.ID, target: selection.env}]},
																				compose_options(view.persona, selection))
						} else if (view.layout.page === 'deploy')
								options = {Erstellen: [{action: 'HEROES', label: "Auftauchzone", target: mouseLoc}]}
						else if (appearArea) {
								const playables = game.playables.map(fgtID => game.personas.get(fgtID)).filter(fgt => !fgt.position)
								options = {Auftauchen: playables.map(fgt => ({action: "Auftauchen", aim: selection.toStr(), label: fgt.name}))}
						}
						menuCoord = {x: e.clientX, y: e.clientY} }
				if (!options)
						options = compose_options(view.persona, selection)
				if (Math.abs(mouseLoc.screenCoord.x - menuCoord.x) < 10 && Math.abs(mouseLoc.screenCoord.y - menuCoord.y) < 10
						&& (game.orders_possible || appearArea)) {
					//Old: send_data('issue', {client: 'ENCOUNTER', issue: `composing menu with touching = ${touching}`})
					view.show_dialog('options', {coord: menuCoord, options: options, location: selection})
					appearArea = null
				}
		}


    /*** MAP: process selection ***/

    function record_coord(e) {
        mouseCoord = {x: e.pageX, y: e.pageY}
    }

    function process_click(e) {
        e.stopPropagation()
        e.preventDefault()
        if (view.dialog)  view.close_dialog()
        const selLoc = Location.from_loc(mouseLoc)
        const ignoreDelta = 4
        if (Math.abs(e.pageX - mouseCoord.x) > ignoreDelta || Math.abs(e.pageY - mouseCoord.y) > ignoreDelta) {
            // console.log(`ENCOUNTER - clicked and moved`)
            return
        }
        const prevSelected = (e.ctrlKey && game.personas.has(selected?.fgt)) ? selected.fgt : null
        if (e.currentTarget.id === 'pinch-zoom') {
            const mapElem = e.currentTarget
            // console.log(`ENCOUNTER - click on map`)
						// if in marking mode then set marker to this coord
						if (marking) {
								// marker = mouseLoc.to_coord()
								const {screenCoord, ...markerLoc} = mouseLoc
								console.log("Client marks position on: ", selLoc)
								send_request('control', {command: 'MARK', loc: selLoc})
						}
            // if (!(selected instanceof Array)) {
            //     selected = {aim: selLoc}
            if (user.isMaster) {
                selected = null
                view.switch_layout('+master')
		            //ToDo: view.select_persona(null)
            }
        } else if (e.currentTarget.dataset.char) {  // (event.currentTarget.tagName === "FIGURE") {
            debugger    //ToDo: is this still used? should be handled directly in token
            const selChar = e.currentTarget.dataset.char
            console.assert(selLoc.fgt === selChar, `Selected char ${selChar} not identified by Location`, selLoc)
            const charData = game.personas.get(selChar)
            if (user.isMaster || game.playables.includes(selChar) || game.playables.includes(charData?.character)) {
                /// create selection group if CTRL key is pressed
                if (e.ctrlKey && charData) {
                    if (!(selected instanceof Array))  selected = (prevSelected) ? [prevSelected] : []
                    if (!(selected.includes(selChar))) selected.push(selChar)
                    charData.token.classList.add("selected")
                } else if (charData.activity || !document.getElementById("action").value)
                    user.switch_character(selChar)
            }
            if (!view.character.activity)
                selected = {aim: selLoc}
        }
		}



		/**** MAP - drop character ****/

    function drag_over(e) {
        e.preventDefault();
        e.dataTransfer.dropEffect = (view.dragParams.typ === 'deploy') ? 'copy' : 'move'
		}

    async function drop_onto(e) {
        e.preventDefault()
        if (view.dragParams.typ === 'deploy') {
						console.log(`MAP - drop variant onto map`)
						view.dragParams.ondrop(Location.from_event(e, view.map.ID), e)
        } else {
            const deployID = e.dataTransfer.getData('char/ID')
            const appear = tokens.find(ent => ent.ID === deployID)
            if (!appear)  return
            mouseLoc.update(e)
            if (game.inEncounter) {
		            console.log(`ENCOUNTER - move token ${appear.ID} to ${mouseLoc.toStr()}`)
								send_request('instruct', {instruct: 'TRANSFER', subject: appear.ID, target: mouseLoc.toStr()})
		            view.select_persona(appear.ID)
            } else {
		            console.log(`ENCOUNTER - move deployment ${appear.ID} to ${mouseLoc.toStr()}`)
		            const sectSECT = view.section?.SECT ?? user.sections.get(game.section)?.SECT
		            send_data(`/deploy/${appear.deployID}`, {
			            ADVT: view.adventure.ID, SECT: sectSECT, CS: deployID,
			            col: Math.round(mouseLoc.col * 10) / 10, row: Math.round(mouseLoc.row * 10) / 10
		            }, 'PATCH')
            }
        }
		}

		function reload_zoom(e) {
				const currentMap = view.map
				setTimeout(() => {
					view.switch_map(currentMap)
					tick().then(() => {
						report_issue("Encouter map was reset by user")
						mapElement = pinchZoom	// Issue: iOS does not re-run onMount or iOS makes a closure of the mount function
						scroll_to(view.persona, true)
					})
				}, 10)
				view.map = null
		}

		function toggle_marking(e) {
				if (!marking) {
						marking = true
				} else {
						// marker = null
						marking = false
						masterMap = null
						send_request('control', {command: 'MARK', loc: null})
				}
		}

</script>


<style lang="sass">
	@use "../colors" as colors

	#pinch-zoom
		grid-area: main
		position: relative
		scrollbar-width: none /* for Firefox */
		user-select: none
		-webkit-user-select: none /* to disable the magnification of the IMG when long-pressing on Safari */

		//&.marking
		//	cursor: crosshair

	#pinch-zoom::-webkit-scrollbar
		display: none

	#pinch-zoom > * :not(.token)
				/*pointer-events: none*/

	#pinch-zoom.marking
		cursor: crosshair


	#mapImg
		-webkit-touch-callout: none		/* disable the IOS popup when long-press on a link */
		-webkit-user-drag: none
		touch-action: none

	#positions
		position: absolute
		bottom: 4px
		left: calc(var(--panel-width) + 16px)
		width: 248px
		padding: 8px
		background: black
		opacity: 50%

		p
			font-weight: bolder

		button
			position: absolute
			top: 8px
			right: 8px
			width: 32px
			height: 32px
			background-color: colors.$primary
			filter: saturate(0)

			&.marking
				filter: saturate(1)

			&.marked
				filter: saturate(1) brightness(3)

			img
				width: 100%
				filter: invert(1)

		.mapSelect-box
			display: flex
			gap: 1em

	#effectsLayer
		display: inline-block
		position: absolute
		opacity: 50%
		background-color: yellow
		border-radius: 50%


		pinch-zoom
			display: block
			position: relative

	.layer
		position: absolute

	.nopinch
		pointer-events: none

	.miniButton
		height: 24px
		width: 30px
		top: 6px

	#crossMark
		position: absolute
		width: 80px
		height: 80px
		animation: colorCycle 1s linear 5 alternate
		translate: -50% -50%

	@keyframes colorCycle
		from
			color: white
		to
			color: black

	svg
		position: absolute
		pointer-events: none

	.arrow
		marker-end: url(#arrowhead)

	#arrowhead
		fill: black

	.aimArea
		position: absolute
		opacity: 50%
		background: yellow
		border-radius: 50%
</style>